export default __webpack_public_path__ + "static/media/library.e3f07d13.png";